/**
 * Persiste l'ultimo username usato per il login (pre-fill al boot).
 * Sul mobile è SecureStore; sul web localStorage è sufficiente:
 * - non è un secret (il nome utente non sblocca nulla)
 * - vincoliamo a `enermed:last-username` per evitare collisioni
 */

const KEY = 'enermed:last-username'

export function loadLastUsername(): string {
  try {
    return localStorage.getItem(KEY) ?? ''
  } catch {
    return ''
  }
}

export function saveLastUsername(username: string): void {
  try {
    localStorage.setItem(KEY, username)
  } catch {
    /* localStorage disabled (private mode) — ignore */
  }
}
